import React, { useEffect, useContext, useState, useRef, Fragment } from "react";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  getSystemSettings,
  formatPrice,
  customStyle
} from "../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Moment from "react-moment";
import Select from "react-select";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { useReactToPrint } from "react-to-print";

//pages & includes
import ReportSidebar from "./ReportSidebar";
import ReportTypeOptions from "../../../components/Reports/ReportTypeOptions";

//context consumer
import { SettingsContext } from "../../../../contexts/Settings";
import { RestaurantContext } from "../../../../contexts/Restaurant";
import { FoodContext } from "../../../../contexts/Food";
import CustomSpinLoader from "../../../components/CustomSpinLoader";
import moment from "moment";

const recipeType = [
  {
    id: 1,
    name: "item"
  },
  {
    id: 2,
    name: "Sub Recipe"
  },
  {
    id: 3,
    name: "Property"
  },
];

const recipesStatus = [
  {
    id: "all",
    name: "All"
  },
  {
    id: "Made",
    name: "Made"
  },
  {
    id: "Not Found",
    name: "Un Made"
  },
];

const RecipeReport = () => {
  const { t } = useTranslation();
  //getting context values here
  let { loading, setLoading, dataPaginating, setDataPaginating, generalSettings } = useContext(SettingsContext);
  let { branchForSearch, ingredientItemForSearch } = useContext(RestaurantContext);
  let { foodForPOS, propertyItemForSearch } = useContext(FoodContext);      

  //all data
  const [reportData, setReportData] = useState(null);
  const [recipeReport, setRecipeReport] = useState(null);
  const [reportItemData, setReportItemData] = useState(null);
  const [activeReport, setActiveReport] = useState(null);
  const [viewDetailReport, setViewDetailReport] = useState(false);

  const componentRef = useRef();
  const componentRef1 = useRef();
  const componentRef2 = useRef();
  const componentRefThermal = useRef();
  const componentRefThermal1 = useRef();
  const componentRefThermal2 = useRef();

  const [startDate, setStartDate] = useState(null);
  const [branch, setBranch] = useState(null);
  const [type, setType] = useState(null);
  const [variation, setVariartion] = useState(null);
  const [item, setItem] = useState(null); 
  const [generatedReport, setGeneratedReport] = useState(false);
  const [generatedItemReport, setGeneratedItemReport] = useState(false);
  const [siteName, setSiteName] = useState("");
  const [option, setOption] = useState("excel");

  const [recipeStatus, setRecipeStatus] = useState(recipesStatus[0]); 
  const [qty, setQty] = useState(1);

  useEffect(() => {
    setSiteName(getSystemSettings(generalSettings, "siteName"));
    setType(recipeType[0]);

    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, [generalSettings, setLoading]);

  const thermalPrint = useReactToPrint({
    content: () => componentRefThermal.current,
    pageStyle: `@page {margin: 17px; }`
  });

  const thermalItemPrint = useReactToPrint({
    content: () => componentRefThermal1.current,
    pageStyle: `@page {margin: 17px; }`
  });

  const thermalRecipeCostPrint = useReactToPrint({
    content: () => componentRefThermal2.current,
    pageStyle: `@page {margin: 17px; }`
  });

  const handleType = (selectedType) => {
    setType(selectedType);
    setItem(null);
  };

  const handleRecipeStatus = (recipe) => {
    setRecipeStatus(recipe);
  };

  const handleItem = (selectedItem) => {
    setItem(selectedItem);
  };

  const handleOption = (e) => {
    const selected = e.target.value;
    setOption(selected);
    if (selected !== "view") {
      setViewDetailReport(false);
    } else if (
      (activeReport === "itemLink" && reportItemData && generatedItemReport) ||
      (activeReport === "recipe" && reportData && generatedReport) ||
      (activeReport === "cost" && recipeReport && generatedReport)
    ) {
      setViewDetailReport(true);
    }
  };

  //select variation
  const handleVariation = (value) => {
    setVariartion(value);
  };

  //get BranchWise reports filter (ITEM LINK WITH RECIPE)
  const getBranchItemSelected = () => {
    setReportItemData(null);
    setGeneratedItemReport(false);
    setViewDetailReport(false);
    setActiveReport("itemLink");

    if (type !== null) {
      setDataPaginating(true);
      const url = BASE_URL + "/settings/get-itemLinkRecipe-report";
      let formData = new FormData();
      formData.append("type_name", type?.name);

      return axios
        .post(url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          setDataPaginating(false);
          setItem(null);
          setVariartion(null);
          setGeneratedItemReport(true);
          setReportItemData(res.data);
          if (option === "excel") {
            setTimeout(() => {
              if (componentRef1.current) {
                componentRef1.current.handleDownload();
              }
            }, 100);
          } else if (option === "view") {
            setViewDetailReport(true);
          } else {
            setTimeout(() => {
              thermalItemPrint();
            }, 100);
          }
          // setQty(1);
        })
        .catch(() => {
          setDataPaginating(false);
        });
    } else {
      toast.error(
        `${_t(t("Please select type and item"))}`,
        {
          position: "bottom-center",
          closeButton: false,
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        }
      );
    }
  };

  //get BranchWise reports filter (RECIPE REPORT)
  const getBranchWiseSelected = () => {
    setReportData(null);
    setRecipeReport(null);
    setGeneratedReport(false);
    setViewDetailReport(false);
    setActiveReport("recipe");

    if (type) {
      if ((item && item?.has_variation === "1") ? (!variation) : false) {
        toast.error(
          `${_t(t("Please select item variation"))}`,
          {
            position: "bottom-center",
            closeButton: false,
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          }
        );
        return;
      }
      setDataPaginating(true);
      const url = BASE_URL + "/settings/get-recipe-report";
      let formData = new FormData();
      formData.append("type_name", type?.name);
      formData.append("item_id", item ? item?.id : "");
      formData.append("variation_id", variation ? variation.variation_id : "");

      return axios
        .post(url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          setDataPaginating(false);
          setItem(null);
          setVariartion(null);
          if (res.data === "Recipe Not Found!") {
            toast.error(res.data);
            return false;
          }
          setGeneratedReport(true);
          setReportData(res.data);
          if (option === "excel") {
            setTimeout(() => {
              if (componentRef.current) {
                componentRef.current.handleDownload();
              }
            }, 100);
          } else if (option === "view") {
            setViewDetailReport(true);
          } else {
            setTimeout(() => {
              thermalPrint();
            }, 100);
          }
          // setQty(1);
        })
        .catch(() => {
          setDataPaginating(false);
        });
    } else {
      toast.error(
        `${_t(t("Please select type and item"))}`,
        {
          position: "bottom-center",
          closeButton: false,
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        }
      );
    }
  };

  //get BranchWise reports filter (RECIPE COST REPORT)
  const getBranchWiseRecipe = () => {
    setReportData(null);
    setRecipeReport(null);
    setGeneratedReport(false);
    setViewDetailReport(false);
    setActiveReport("cost");

    if (type && branch && startDate) {
      if ((item && item?.has_variation === "1") ? (!variation) : false) {
        toast.error(
          `${_t(t("Please select item variation"))}`,
          {
            position: "bottom-center",
            closeButton: false,
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          }
        );
        return;
      }
      setDataPaginating(true);
      const url = BASE_URL + "/settings/get-recipe-item-costing-report";
      let formData = new FormData();
      const date = moment(startDate).format("YYYY-MM-DD");
      formData.append("type_name", type?.name);
      formData.append("date", date);
      formData.append("branch_id", branch?.id || "");
      formData.append("item_id", item ? item?.id : "");
      formData.append("variation_id", variation ? variation.variation_id : "");

      return axios
        .post(url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          setDataPaginating(false);
          setItem(null);
          setVariartion(null);
          if (res.data === "Recipe Not Found!") {
            toast.error(res.data);
            return false;
          }
          setGeneratedReport(true);
          setRecipeReport(res.data);
          if (option === "excel") {
            setTimeout(() => {
              if (componentRef2.current) {
                componentRef2.current.handleDownload();
              }
            }, 100);
          } else if (option === "view") {
            setViewDetailReport(true);
          } else {
            setTimeout(() => {
              thermalRecipeCostPrint();
            }, 100);
          }
          // setQty(1);
        })
        .catch(() => {
          setDataPaginating(false);
        });
    } else {
      toast.error(
        `${_t(t("Please select date, branch, type and item"))}`,
        {
          position: "bottom-center",
          closeButton: false,
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        }
      );
    }
  };

  return (
    <>
      <Helmet>
        <title>{_t(t("Recipe Report"))}</title>
      </Helmet>

      <ReactHTMLTableToExcel
        id="recipe-report-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="table-to-xls"
        filename="Recipe Report"
        sheet="sheet 1"
        buttonText="Recipe Detail"
        ref={componentRef}
      />  

      <ReactHTMLTableToExcel
        id="item-recipe-report-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="table-xls"
        filename="Item Recipe Report"
        sheet="sheet 1"
        buttonText="Recipe Item Detail"
        ref={componentRef1}
      /> 

      <ReactHTMLTableToExcel
        id="cost-recipe-report-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="table-cost-xls"
        filename="Recipe Costing Report"
        sheet="sheet 1"
        buttonText="Recipe Cost Detail"
        ref={componentRef2}
      />

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ReportSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    {/* next page data spin loading */}
                    <CustomSpinLoader loading={loading || dataPaginating}/>
                    
                    <div key="smtp-form">
                      <div className="gx-2 align-items-center t-pt-15 t-pb-15">
                        <div className="row t-mb-15 mb-md-0">
                          <ul className="t-list fk-breadcrumb col-6">
                            <li className="fk-breadcrumb__list">
                              <span className="pl-3 t-link fk-breadcrumb__link text-capitalize">
                                {_t(t("Recipe Report"))}
                              </span>
                            </li>
                          </ul>
                          <div className="col-6 d-flex justify-content-end">
                            <ReportTypeOptions
                              selectedOption={option}
                              onChange={handleOption}
                              view={true}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-2">
                          <DatePicker
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control sm-text py-2 t-mb-15 mb-md-0"
                            placeholderText={_t(t("Date"))}
                            shouldCloseOnSelect={true}
                          />
                        </div>

                        <div className="col-3">
                          <Select
                            options={branchForSearch ? branchForSearch : []}
                            getOptionLabel={(opt) => opt.name}
                            getOptionValue={(opt) => opt.id}
                            isClearable
                            classNamePrefix="select"
                            onChange={(b) => setBranch(b)}
                            value={branch || ""}
                            styles={customStyle}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select branch")) + ".."}
                          />
                        </div>

                        <div className="col-2">
                          <Select
                            options={recipeType}
                            getOptionLabel={(opt) => opt.name}
                            getOptionValue={(opt) => opt.id}
                            value={type}
                            classNamePrefix="select"
                            className="table-text text-capitalize"
                            onChange={handleType} 
                            styles={customStyle} 
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select a type")) + ".."}
                          />
                        </div>

                        <div className="col-2">
                          <Select
                            options={recipesStatus}
                            getOptionLabel={(opt) => opt.name}
                            getOptionValue={(opt) => opt.id}
                            value={recipeStatus}
                            classNamePrefix="select"
                            className="table-text"
                            onChange={handleRecipeStatus} 
                            styles={customStyle}                                 
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select item")) + ".."}
                          />
                        </div>

                        <div className="col-3">
                          <Select
                            options={type && (type.name === "item" ? (foodForPOS ? foodForPOS : []) : (type.name === "Sub Recipe" ? (ingredientItemForSearch ? ingredientItemForSearch : []) : (propertyItemForSearch ? propertyItemForSearch : [])))}
                            getOptionLabel={(opt) => opt.name}
                            getOptionValue={(opt) => opt.id}
                            value={item}
                            isClearable
                            classNamePrefix="select"
                            className="table-text"
                            onChange={handleItem} 
                            styles={customStyle}                                 
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select item")) + ".."}
                          />
                        </div> 
                      </div> 

                      <div className="row mt-3 d-flex align-items-center">
                        <div className="col-2"></div>
                        <div className="col-3 px-1 d-flex align-items-center flex-wrap">
                          {item && item.has_variation === "1" && (
                            item?.variation_recipe?.map((vItem) => (
                              <div className="form-check mx-1" key={vItem.food_with_variation_id}>
                                <input
                                  className="form-check-input pointer-cursor"                                                
                                  type="radio" 
                                  name="variations"                                                 
                                  id={vItem.variation_name} 
                                  checked={variation?.variation_name === vItem.variation_name}
                                  onChange={() => handleVariation(vItem)}
                                  required                                                
                                /> 
                                <label className="form-radio-label mx-1 text-capitalize pointer-cursor" htmlFor={vItem.variation_name}>
                                  {vItem.variation_name} 
                                </label>
                              </div>
                            ))
                          )}
                        </div>

                        <div className="col-1">
                          <input
                            className="form-control rounded-25"
                            type="number"
                            onKeyDown={(evt) =>
                              ["e", "E", "+", "-", "ArrowUp", "ArrowDown"].includes(evt.key) &&
                              evt.preventDefault()
                            }
                            onWheel={(e) => e.target.blur()}  
                            min="1"
                            value={qty}
                            onChange={(e) => setQty(parseFloat(e.target.value))}
                            placeholder="Recipe Qty"
                          />
                        </div> 

                        <div className="col-2 t-mb-15 mb-md-0 d-none d-md-block text-right">
                          <button
                            className="ml-1 btn btn-block btn-primary sm-text py-2 rounded"
                            onClick={() => getBranchItemSelected()}
                          >
                            ITEM LINK WITH RECIPE
                          </button>
                        </div>
                        <div className="col-2 t-mb-15 mb-md-0 d-none d-md-block text-right">
                          <button
                            className="ml-1 btn btn-block btn-primary sm-text py-2 rounded"
                            onClick={() => getBranchWiseRecipe()}
                          >
                            RECIPE COST REPORT
                          </button>
                        </div>
                        <div className="col-2 t-mb-15 mb-md-0 d-none d-md-block text-right">
                          <button
                            className="ml-1 btn btn-block btn-primary sm-text py-2 rounded"
                            onClick={() => getBranchWiseSelected()}
                          >
                            RECIPE REPORT
                          </button>
                        </div>
                      </div>

                      {/* Active Report View / Print / Excel Tables */}
                      {/* 1. Recipe Report */}
                      <div className={viewDetailReport && activeReport === "recipe" ? "" : "d-none"}>
                        <div ref={componentRefThermal}>
                          {reportData && generatedReport && (
                            <div className="fk-print container-fluid mt-2" style={viewDetailReport ? {} : { margin: "20px" }}>
                              {viewDetailReport && (
                                <div className="text-center my-2">
                                  <h3 className="xslg-text font-weight-bold my-1">{siteName}</h3>
                                  <h3 className="xslg-text my-1">{_t(t("Recipe Report"))}</h3>
                                  <p className="mb-0 text-muted sm-text">
                                    Print Time: <Moment format="LLL">{new Date()}</Moment>
                                  </p>
                                </div>
                              )}
                              <div
                                style={{ maxHeight: viewDetailReport ? "28rem" : "auto" }}
                                className={viewDetailReport ? "bill_modal_scroll table-responsive" : "table-responsive"}
                              >
                                <RecipeDetailTable
                                  reportData={reportData}
                                  type={type}
                                  qty={qty}
                                  siteName={siteName}
                                  viewDetailReport={viewDetailReport}
                                  tableId="table-to-xls"
                                  t={t}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                      {/* 2. Item Link with Recipe Report */}
                      <div className={viewDetailReport && activeReport === "itemLink" ? "" : "d-none"}>
                        <div ref={componentRefThermal1}>
                          {reportItemData && generatedItemReport && (
                            <div className="fk-print container-fluid mt-3" style={viewDetailReport ? {} : { margin: "20px" }}>
                              {viewDetailReport && (
                                <div className="text-center my-2">
                                  <h3 className="xslg-text font-weight-bold my-1">{siteName}</h3>
                                  <h3 className="xslg-text my-1">{_t(t("Recipe Report"))}</h3>
                                  <p className="mb-0 text-muted sm-text">
                                    {_t(t("Item Type"))}: {type?.name === "item" ? "Food Item" : type?.name}
                                  </p>
                                  <p className="mb-0 text-muted sm-text">
                                    Print Time: <Moment format="LLL">{new Date()}</Moment>
                                  </p>
                                </div>
                              )}
                              <div
                                style={{ maxHeight: viewDetailReport ? "28rem" : "auto" }}
                                className={viewDetailReport ? "bill_modal_scroll table-responsive" : "table-responsive"}
                              >
                                <ItemLinkRecipeTable
                                  reportItemData={reportItemData}
                                  type={type}
                                  recipeStatus={recipeStatus}
                                  siteName={siteName}
                                  viewDetailReport={viewDetailReport}
                                  tableId="table-xls"
                                  t={t}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                      {/* 3. Recipe Costing Report */}
                      <div className={viewDetailReport && activeReport === "cost" ? "" : "d-none"}>
                        <div ref={componentRefThermal2}>
                          {recipeReport && generatedReport && (
                            <div className="fk-print container-fluid mt-3" style={viewDetailReport ? {} : { margin: "20px" }}>
                              {viewDetailReport && (
                                <div className="text-center my-2">
                                  <h3 className="xslg-text font-weight-bold my-1">{siteName}</h3>
                                  {branch && <h4 className="my-1 font-weight-bold">{branch.name}</h4>}
                                  <h3 className="xslg-text my-1">{_t(t("Recipe Costing Report"))}</h3>
                                  {startDate && (
                                    <p className="mb-0 text-muted sm-text">
                                      <Moment format="LLL">{startDate}</Moment>
                                    </p>
                                  )}
                                  <p className="mb-0 text-muted sm-text">
                                    Print Time: <Moment format="LLL">{new Date()}</Moment>
                                  </p>
                                </div>
                              )}
                              <div
                                style={{ maxHeight: viewDetailReport ? "28rem" : "auto" }}
                                className={viewDetailReport ? "bill_modal_scroll table-responsive" : "table-responsive"}
                              >
                                <RecipeCostingTable
                                  recipeReport={recipeReport}
                                  type={type}
                                  branch={branch}
                                  startDate={startDate}
                                  siteName={siteName}
                                  viewDetailReport={viewDetailReport}
                                  tableId="table-cost-xls"
                                  t={t}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                    </div>                                          
                  </div>
                </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
    </>
  );
};

const RecipeDetailTable = ({ reportData, type, qty, siteName, viewDetailReport, tableId, t }) => {
  return (
    <table className="table table-bordered table-hover min-table-height mt-3" id={tableId}>
      {!viewDetailReport && (
        <thead className="align-middle">
          <tr style={{ border: "0px" }}>
            <th colSpan="4" style={{ border: "0px" }}>
              <div className="text-center">
                <h3 className="mb-0 mt-1">{siteName}</h3>
                <h3 className="mt-0 mt-1">{_t(t("Recipe Report"))}</h3>
                <p className="mb-0 mt-1">
                  Print Time: <Moment format="LLL">{new Date()}</Moment>
                </p>
              </div>
            </th>
          </tr>
        </thead>
      )}
      {reportData && reportData.length > 0 &&
        reportData.map((item, index) => (
          <Fragment key={index}>
            <thead className="align-middle">
              <tr style={viewDetailReport ? { position: "sticky", top: "-0.1px", backgroundColor: "#f8f9fa" } : {}}>
                <th scope="col" className="text-capitalize align-middle text-center border-1 border-dark p-2 bg-light">{_t(t("Item Type"))}</th>
                <th scope="col" className="text-capitalize align-middle text-center border-1 border-dark p-2 bg-light">{_t(t("Item Name"))}</th>
                {type?.name === "Sub Recipe" ? (
                  <th scope="col" className="text-capitalize align-middle text-center border-1 border-dark p-2 bg-light">{_t(t("Unit"))}</th>
                ) : (
                  <th scope="col" className="text-capitalize align-middle text-center border-1 border-dark p-2 bg-light">{_t(t("Variation"))}</th>
                )}
                <th scope="col" className="text-capitalize align-middle text-center border-1 border-dark p-2 bg-light">{_t(t("Qty"))}</th>
              </tr>
            </thead>
            <tbody className="align-middle">
              <tr>
                <td className="text-capitalize align-middle text-center border-1 border-dark p-1">{item.type}</td>
                <td className="text-capitalize align-middle text-center border-1 border-dark p-1">{item.item}</td>
                {item.type === "Sub Recipe" ? (
                  <td className="text-capitalize align-middle text-center border-1 border-dark p-1">{item.unit_name}</td>
                ) : (
                  <td className="text-capitalize align-middle text-center border-1 border-dark p-1">{item.variation ? item.variation : "-"}</td>
                )}
                <td className="text-capitalize align-middle text-center border-1 border-dark p-1">{qty ? qty : 1}</td>
              </tr>
              {item && item.recipe_detail?.length > 0 && (
                <>
                  <tr>
                    <th scope="col" className="text-capitalize align-middle text-center border-1 border-dark p-1 table-secondary">{_t(t("Ingredient Item"))}</th>
                    <th scope="col" className="text-capitalize align-middle text-center border-1 border-dark p-1 table-secondary">{_t(t("Order Type"))}</th>
                    <th scope="col" className="text-capitalize align-middle text-center border-1 border-dark p-1 table-secondary">{_t(t("Qty"))}</th>
                    <th scope="col" className="text-capitalize align-middle text-center border-1 border-dark p-1 table-secondary">{_t(t("Unit"))}</th>
                  </tr>
                  {item.recipe_detail.map((itemDetail, ind) => (
                    <tr key={ind}>
                      <td className="text-capitalize align-middle text-center border-1 border-dark p-1">{itemDetail.item_name}</td>
                      <td className="text-capitalize align-middle text-center border-1 border-dark p-1">{itemDetail.order_type}</td>
                      <td className="text-capitalize align-middle text-center border-1 border-dark p-1">
                        {itemDetail.qty * (qty ? (qty / (item.type === "Sub Recipe" ? item.qty : 1)) : 1)}
                      </td>
                      <td className="text-capitalize align-middle text-center border-1 border-dark p-1">{itemDetail.unit_name}</td>
                    </tr>
                  ))}
                </>
              )}
            </tbody>
          </Fragment>
        ))}
    </table>
  );
};

const ItemLinkRecipeTable = ({ reportItemData, type, recipeStatus, siteName, viewDetailReport, tableId, t }) => {
  return (
    <table className="table table-bordered table-hover min-table-height mt-3" id={tableId}>
      {!viewDetailReport && (
        <thead className="align-middle">
          <tr style={{ border: "0px" }}>
            <th colSpan="3" style={{ border: "0px" }}>
              <div className="text-center">
                <h3 className="mb-0">{siteName}</h3>
                <h3 className="mt-0">{_t(t("Recipe Report"))}</h3>
                <p className="mb-0">
                  {_t(t("Item Type"))}: {type?.name === "item" ? "Food Item" : type?.name}
                </p>
                <p className="mb-0">
                  Print Time: <Moment format="LLL">{new Date()}</Moment>
                </p>
              </div>
            </th>
          </tr>
        </thead>
      )}
      <thead className="align-middle">
        <tr style={viewDetailReport ? { position: "sticky", top: "-0.1px", backgroundColor: "#f8f9fa" } : {}}>
          <th scope="col" className="text-capitalize align-middle text-center border-1 border-dark p-2 bg-light">{_t(t("Item Name"))}</th>
          <th scope="col" className="text-capitalize align-middle text-center border-1 border-dark p-2 bg-light">{_t(t("Variation"))}</th>
          <th scope="col" className="text-capitalize align-middle text-center border-1 border-dark p-2 bg-light">{_t(t("Status"))}</th>
        </tr>
      </thead>
      <tbody className="align-middle">
        {reportItemData && reportItemData.length > 0 &&
          reportItemData.map((item, index) => {
            if (recipeStatus.id !== "all" && recipeStatus.id !== item.status) {
              return null;
            }
            return (
              <tr key={index}>
                <td className="text-capitalize align-middle text-center border-1 border-dark p-1">{item.name}</td>
                <td className="text-capitalize align-middle text-center border-1 border-dark p-1">{item.variations ? item.variations.name : "-"}</td>
                <td className="text-capitalize align-middle text-center border-1 border-dark p-1">{item.status}</td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};

const RecipeCostingTable = ({ recipeReport, type, branch, startDate, siteName, viewDetailReport, tableId, t }) => {
  return (
    <table className="table table-bordered table-hover min-table-height mt-3" id={tableId}>
      {!viewDetailReport && (
        <thead className="align-middle">
          <tr style={{ border: "0px" }}>
            <th colSpan="6" style={{ border: "0px" }}>
              <div className="text-center">
                <h3 className="mb-0 mt-1">{siteName}</h3>
                {branch && <h4 className="mb-0 mt-1">{branch.name}</h4>}
                <h3 className="mt-0 mt-1">{_t(t("Recipe Costing Report"))}</h3>
                {startDate && <p className="mb-0"><Moment format="LLL">{startDate}</Moment></p>}
                <p className="mb-0">Print Time: <Moment format="LLL">{new Date()}</Moment></p>
              </div>
            </th>
          </tr>
        </thead>
      )}
      {recipeReport && recipeReport.length > 0 &&
        recipeReport.map((item, index) => {
          let currentRecipeAmount = 0;
          return (
            <Fragment key={index}>
              <thead className="align-middle">
                <tr style={viewDetailReport ? { position: "sticky", top: "-0.1px", backgroundColor: "#f8f9fa" } : {}}>
                  <th scope="col" className="text-capitalize align-middle text-center border-1 border-dark p-2 bg-light">{_t(t("Item Type"))}</th>
                  <th scope="col" className="text-capitalize align-middle text-center border-1 border-dark p-2 bg-light">{_t(t("Item Name"))}</th>
                  {type?.name === "Sub Recipe" ? (
                    <th scope="col" className="text-capitalize align-middle text-center border-1 border-dark p-2 bg-light">{_t(t("Unit"))}</th>
                  ) : (
                    <th scope="col" className="text-capitalize align-middle text-center border-1 border-dark p-2 bg-light">{_t(t("Variation"))}</th>
                  )}
                  <th scope="col" className="text-capitalize align-middle text-center border-1 border-dark p-2 bg-light">{_t(t("Qty"))}</th>
                  <th scope="col" className="text-capitalize align-middle text-center border-1 border-dark p-2 bg-light" colSpan={2}></th>
                </tr>
              </thead>
              <tbody className="align-middle">
                <tr>
                  <td className="text-capitalize align-middle text-center border-1 border-dark p-1">{item.type}</td>
                  <td className="text-capitalize align-middle text-center border-1 border-dark p-1">{item.item}</td>
                  {item.type === "Sub Recipe" ? (
                    <td className="text-capitalize align-middle text-center border-1 border-dark p-1">{item.unit_name}</td>
                  ) : (
                    <td className="text-capitalize align-middle text-center border-1 border-dark p-1">{item.variation ? item.variation : "-"}</td>
                  )}
                  <td className="text-capitalize align-middle text-center border-1 border-dark p-1">{item.qty ? item.qty : 1}</td>
                  <td className="text-capitalize align-middle text-center border-1 border-dark p-1" colSpan={2}></td>
                </tr>
                {item && item.recipe_detail?.length > 0 && (
                  <>
                    <tr>
                      <th scope="col" className="text-capitalize align-middle text-center border-1 border-dark p-1 table-secondary">{_t(t("Ingredient Item"))}</th>
                      <th scope="col" className="text-capitalize align-middle text-center border-1 border-dark p-1 table-secondary">{_t(t("Order Type"))}</th>
                      <th scope="col" className="text-capitalize align-middle text-center border-1 border-dark p-1 table-secondary">{_t(t("Qty"))}</th>
                      <th scope="col" className="text-capitalize align-middle text-center border-1 border-dark p-1 table-secondary">{_t(t("Unit"))}</th>
                      <th scope="col" className="text-capitalize align-middle text-center border-1 border-dark p-1 table-secondary">{_t(t("Cost"))}</th>
                      <th scope="col" className="text-capitalize align-middle text-center border-1 border-dark p-1 table-secondary">{_t(t("Amount"))}</th>
                    </tr>
                    {item.recipe_detail.map((itemDetail, ind) => {
                      const amount = Number(formatPrice(itemDetail.amount));
                      currentRecipeAmount += Number(amount);
                      return (
                        <tr key={ind}>
                          <td className="text-capitalize align-middle text-center border-1 border-dark p-1">{itemDetail.item_name}</td>
                          <td className="text-capitalize align-middle text-center border-1 border-dark p-1">{itemDetail.order_type}</td>
                          <td className="text-capitalize align-middle text-center border-1 border-dark p-1">{itemDetail.qty ? itemDetail.qty : 1}</td>
                          <td className="text-capitalize align-middle text-center border-1 border-dark p-1">{itemDetail.unit_name}</td>
                          <td className="text-capitalize align-middle text-center border-1 border-dark p-1">{itemDetail.avgCost}</td>
                          <td className="text-capitalize align-middle text-center border-1 border-dark p-1">{amount}</td>
                        </tr>
                      );
                    })}
                    <tr>
                      <td className="text-capitalize align-middle text-center border-1 border-dark p-1" colSpan={4}></td>
                      <td className="text-capitalize align-middle text-center border-1 border-dark p-1 font-weight-bold">{_t(t("Recipe Total"))}</td>
                      <td className="text-capitalize align-middle text-center border-1 border-dark p-1 font-weight-bold">{formatPrice(currentRecipeAmount)}</td>
                    </tr>
                    <tr>
                      <td className="text-capitalize align-middle text-center border-1 border-dark p-1" colSpan={4}></td>
                      <td className="text-capitalize align-middle text-center border-1 border-dark p-1 font-weight-bold">{_t(t("Per Piece"))}</td>
                      <td className="text-capitalize align-middle text-center border-1 border-dark p-1 font-weight-bold">{formatPrice(currentRecipeAmount / Number(item.qty))}</td>
                    </tr>
                  </>
                )}
              </tbody>
            </Fragment>
          );
        })}
    </table>
  );
};

export default RecipeReport;